import routes from '../routes/route';
import FormInputTypes from '../components/atoms/formEnums/formInputTypes';
import viewLenguageCountriesRelated from './viewLenguageCountriesRelated';
import { IconType } from '../components/atoms/icon/icon';
import tableLanguageReferences from './tableLanguageReferences';
export default {
  attributeName: 'languages',
  isDragable: false,
  canOpen: false,
  canEdit: true,
  canCreate: true,
  canRemove: true,
  emptyMessage: "You don't have any languages, click on the +new button to make a new one.",
  sessionParams: [],
  sessionParams: [],
  fields: [
    {
      attributeName: 'code',
      label: 'Code',
      type: FormInputTypes.TEXT_INPUT.TEXT,
      helpText: 'Base language code.',
      canOrder: true,
      canFilter: true,
      width: '12rem',
      canCreate: true,
    },
    {
      attributeName: 'name',
      label: 'Name',
      type: FormInputTypes.TEXT_INPUT.TEXT,
      helpText: 'Language name.',
      canOrder: true,
      canFilter: true,
      width: '12rem',
      canCreate: true,
    },
    {
      attributeName: 'countries',
      label: 'Countries',
      type: FormInputTypes.RELATIONSHIPFILTER,
      canEdit: true,
      canCreate: true,
      canFilter: false,
      configFile: viewLenguageCountriesRelated,
      width: '24rem',
      default: [],

    },
    {
      attributeName: 'enabled',
      helpText: 'Whether this language is enabled.',
      label: 'Enabled',
      default: false,
      canEdit: true,
      canOrder: false,
      className: 'text-center',
      type: FormInputTypes.CHECKBOX,
    },
    {
      attributeName: 'id',
      label: 'Link to references',
      type: FormInputTypes.BUTTON_POPUP,
      iconSize: '2x',
      icon: IconType.LINK,
      helpText: 'open list of language references',
      canOrder: false,
      canFilter: false,
      exactWidth: '100px',
      openUrl: 'languageReferences',
      enabledWhen: { field: 'hasConfig', values: true },
      formConfig: {
        title: 'Language References',
        description: 'This language is referenced by the following apps:',
        type: FormInputTypes.TABLE,
        fields: [
          {
            attributeName: 'languageReferences',
            type: FormInputTypes.TABLE,
            label: '',
            helpText: '',
            configFile: tableLanguageReferences
          }
        ]
      }
    }
  ],
};